import { useContext } from 'react'
import PropTypes from 'prop-types'
import swal from 'sweetalert2'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import useProviderDeadlineGroup from '@hooks/useProviderDeadlineGroup'

const confirmDelete = (deleteProviderDeadlineGroup, deleteFn) => {
  const deleteProviderDeadlineGroupPayload = {
    callbacks: {
      action: deleteFn,
    },
    toastText: 'Deadline Group Deleted',
  }

  swal.fire({
    confirmButtonColor: '#DD6B55',
    confirmButtonText: 'Yes, delete it.',
    icon: 'warning',
    showCancelButton: true,
    text: 'Are you sure?',
    title: 'Delete Deadline Group?',
  }).then(({ value }) => {
    if (value){
      deleteProviderDeadlineGroup(deleteProviderDeadlineGroupPayload)
    }
  })
}

const renderSecondaryText = (deadlineDefault, deadlineCount) => {
  const defaultStatus = deadlineDefault ? 'Default' : 'Custom'
  const renderDeadlineCount = deadlineCount === 1 ? '1 Deadline' : `${deadlineCount} Deadlines`

  return (
    `${defaultStatus} (${renderDeadlineCount})`
  )
}

const ProviderDeadlineGroupListItem = (props) => {
  const { providerDeadlineGroup } = props

  const pageContext = useContext(PageContext)
  const { callbacks } = pageContext
  const { deleteProviderDeadlineGroup } = callbacks || {}

  const {
    callbacks: {
      createOrEditProviderDeadlineGroup,
      deleteProviderDeadlineGroup: deleteFn,
    },
    deadlineCount,
    providerDeadlineGroup: {
      default: deadlineDefault,
      id,
      title,
    },
  } = useProviderDeadlineGroup(providerDeadlineGroup)

  return (
    <DashboardModuleListItem
      secondaryText={renderSecondaryText(deadlineDefault, deadlineCount)}
      title={`#${id} ${title}`}
    >
      <DashboardModuleListItem.Actions>
        <DashboardModuleListItem.Icon onClick={() => createOrEditProviderDeadlineGroup()} marginRight="medium" type="edit" />
        <DashboardModuleListItem.Icon onClick={() => confirmDelete(deleteProviderDeadlineGroup, deleteFn)} type="delete" />
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

ProviderDeadlineGroupListItem.propTypes = {
  providerDeadlineGroup: PropTypes.object.isRequired,
}

export default ProviderDeadlineGroupListItem
